import { SHARE_CONSTANTS } from 'src/constants/other';
import { SHARE_ROUTE } from 'src/constants/routes';
import { ObjectValues } from 'src/types/object-values';
import * as analytics from 'src/utils/analytics';

const CAN_USE_DOM = typeof window !== 'undefined';

export type SocialType = ObjectValues<typeof SHARE_CONSTANTS>;
export type ShareType = 'general' | 'results';

type params = {
  socialType: SocialType;
  shareData?: { d: string };
  ogTitle?: string;
  ogDescription?: string;
  domainName?: string;
};

export const share = ({ socialType, shareData, ogTitle = '', ogDescription = '', domainName = '' }: params) => {
  if (!CAN_USE_DOM) {
    return;
  }

  const domain = domainName ? domainName : ogTitle ? window.location.href : window.location.origin;

  const titleProp = document.querySelector('meta[property="og:title"]');
  const title = ogTitle || (titleProp ? titleProp.getAttribute('content') : '');
  const descriptionProp = document.querySelector('meta[property="og:description"]');
  const description = ogDescription || (descriptionProp ? descriptionProp.getAttribute('content') : '');
  const isMobile = !!window.ontouchstart && window.matchMedia('(max-width: 1024px)').matches;
  const encode = encodeURIComponent;

  if (socialType === 'facebook') {
    const fbURL = 'https://www.facebook.com/sharer.php?u=';

    window.open(
      `${fbURL}${domain}${shareData ? encode(`${SHARE_ROUTE}?d=${shareData.d}`) : ''}`,
      'sharer',
      'width=555,height=600',
    );
  }

  if (socialType === 'x') {
    const twURL = 'https://twitter.com/intent/tweet?url=';
    const twText = `${title}\n${description}`;
    const finalURL = `${twURL}${domain}&text=${encode(`${twText}`)}`;

    const shareWindow = window.open(finalURL, 'ShareOnTwitter', 'width=555,height=600');
    if (shareWindow) shareWindow.opener = null;
  }

  if (socialType === 'whatsapp') {
    const text = `${title}\n${description}\n${domain}`;
    const waShareLink = `https://wa.me/?text=${encode(`${text}`)}`;

    if (!isMobile) {
      window.open(waShareLink, '_blank');
    } else {
      window.location.href = waShareLink;
    }
  }

  if (!shareData) {
    analytics.onGeneralShareChoice(socialType);
  } else {
    analytics.onResultsShareChoice(socialType);
  }
};
